"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.showPreviewBoxWithDataFromImage = exports.renderPreviewBox = exports.PreviewBox = void 0;
var tslib_1 = require("tslib");
var app_1 = require("app");
var React = require("react");
var ReactDOM = require("react-dom");
var react_1 = require("react");
var webexUI_1 = require("webexUI");
var PreviewBox = /** @class */ (function (_super) {
    tslib_1.__extends(PreviewBox, _super);
    function PreviewBox(props) {
        var _this = _super.call(this, props) || this;
        _this.closePopup = function () {
            _this.setState({
                isPopupOpened: false,
            }, function () {
                _this.props.closePopup();
            });
        };
        var startTime = +app_1.UrlService.GetQueryValueFromUrl('t', props.videoUrl) || 0;
        _this.state = {
            isPopupOpened: props.isPopupOpened,
            reactDOMRenderId: props.reactDOMRenderId,
            playerVars: { start: startTime },
        };
        return _this;
    }
    PreviewBox.getDerivedStateFromProps = function (props, state) {
        if (props.reactDOMRenderId && props.reactDOMRenderId !== state.reactDOMRenderId) {
            return {
                isPopupOpened: props.isPopupOpened,
                reactDOMRenderId: props.reactDOMRenderId,
            };
        }
        else if (!props.reactDOMRenderId && props.isPopupOpened !== state.isPopupOpened) {
            return {
                isPopupOpened: props.isPopupOpened,
            };
        }
        return null;
    };
    PreviewBox.prototype.render = function () {
        var _a = this.props, videoUrl = _a.videoUrl, popupArialLabel = _a.popupArialLabel, closeButtonArialLabel = _a.closeButtonArialLabel, container = _a.container;
        return (React.createElement(webexUI_1.Popup, { className: "preview-box", onClose: this.closePopup, isOpened: this.state.isPopupOpened, popupAriaLabel: popupArialLabel, closeButtonArialLabel: closeButtonArialLabel, isCloseButton: true, container: container },
            React.createElement(webexUI_1.VideoPlayer, { videoUrl: videoUrl, onVideoEvent: app_1.GTM.iframeYoutubeVideo, cookieCategoriesAcceptance: app_1.UtilService.getCookieCategoriesAcceptance(), playerVars: this.state.playerVars })));
    };
    return PreviewBox;
}(react_1.Component));
exports.PreviewBox = PreviewBox;
var previewBoxId = 'preview-box-element';
var previewBoxContainer = document.getElementById(previewBoxId);
function closePopup() {
    app_1.overlayService.disableBodyScrollLock();
}
function renderPreviewBox(url, popupArialLabel, closeButtonArialLabel) {
    if (popupArialLabel === void 0) { popupArialLabel = ''; }
    if (closeButtonArialLabel === void 0) { closeButtonArialLabel = ''; }
    app_1.overlayService.enableBodyScrollLock();
    if (!previewBoxContainer) {
        var previewBox = document.createElement('div');
        previewBox.id = previewBoxId;
        document.body.appendChild(previewBox);
        previewBoxContainer = previewBox;
    }
    ReactDOM.render(React.createElement(PreviewBox, { videoUrl: url, isPopupOpened: true, closePopup: closePopup, popupArialLabel: popupArialLabel, closeButtonArialLabel: closeButtonArialLabel, reactDOMRenderId: app_1.DateService.getTimestamp(), container: previewBoxContainer }), previewBoxContainer);
}
exports.renderPreviewBox = renderPreviewBox;
var showPreviewBoxWithDataFromImage = function (event, el, isAnchor) {
    if (isAnchor === void 0) { isAnchor = false; }
    var url = !isAnchor ? el.getAttribute('data-url') : el.getAttribute('href');
    var popupArialLabel = el.getAttribute('data-popup-aria-label');
    var closeButtonArialLabel = el.getAttribute('data-close-button-aria-label');
    if (webexUI_1.VideoService.checkIsValidVideo(url)) {
        event.preventDefault();
        renderPreviewBox(url, popupArialLabel, closeButtonArialLabel);
    }
};
exports.showPreviewBoxWithDataFromImage = showPreviewBoxWithDataFromImage;
